import { Navigate, useSearchParams } from 'react-router-dom';
import { getStoredBusinessId } from '../../hooks/useSelectedBusiness';

/** Redirects an old flat route (e.g. /reviews?businessId=ID) to the nested
 *  /client/ID/<section>. Falls back to the last-used client, else "Все клиенты". */
type ClientSection = 'reviews' | 'services' | 'keywords' | 'content' | 'reports';

export function RedirectToClientSection({ section }: { section: ClientSection }) {
  const [sp] = useSearchParams();
  const id = sp.get('businessId') || getStoredBusinessId();
  return id
    ? <Navigate to={`/client/${id}/${section}`} replace />
    : <Navigate to="/businesses" replace />;
}
